if (!customElements.get('custom-modal')) {
  class Modal extends HTMLElement {
    constructor() {
      super();
      this.activeId = null;
    }
    
    close() {
      document.querySelector(`[data-drawer-action="open"][data-drawer-id="${this.activeId}"]`)?.focus();
      setTimeout(() => {
        this.classList.remove(this.direction);
      }, 500);
      
      switch(this.direction) {
        case 'left':
          this.classList.add('opacity-0', '-translate-x-full')
          setTimeout(() => {
            this.classList.remove('opacity-0', '-translate-x-full')
          }, 500);
        break;
        case 'center':
          this.classList.add('opacity-0');
          setTimeout(() => {
            this.classList.remove('opacity-0');
          }, 500);
        break;
        case 'right': 
          this.classList.add('opacity-0', 'translate-x-full')
          setTimeout(() => {
            this.classList.remove('opacity-0', 'translate-x-full')
          }, 500);
        break;
      }
        
      this.template.innerHTML = this.innerHTML;
      
      setTimeout(() => {
        this.classList.add('hidden');
        document.body.classList.remove('custom-modal');
        if (!document.querySelector('mini-cart')?.cartModalOpen) document.body.classList.remove('overlay');
        this.classList.remove('top-0', 'bottom-0', 'left-0', 'w-full', 'h-full', 'z-[1001]', 'opacity-0', 'transition-all', 'duration-500');
        this.innerHTML = '';
        this.activeId = null;
      }, 500);
      
    }

    trapFocus() {
      const focusableElements = this.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
      this.focusableClose = this.querySelector('[data-drawer-action="close"]');
      this.firstFocusableEl = focusableElements[0];  
      this.lastFocusableEl = focusableElements[focusableElements.length - 1];
      this.addEventListener('keydown', (e) => this.focusListener(e));
    }

    focusListener(e) {
      if (e.key === 'Tab' || e.keyCode === 9) {
        if (e.shiftKey ) /* shift + tab */ {
          if (e.target === this.firstFocusableEl) {
            this.lastFocusableEl.focus();
            e.preventDefault();
          }
        } else /* tab */ {
          if (e.target === this.lastFocusableEl) {
            this.firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      }
    }
    
    connectedCallback() {
      ['click'].forEach(eventType => window.addEventListener(eventType, (e) => {
        if (e.target.tagName.toLowerCase() === 'custom-modal') {
          this.close();
        }
        
        const clickedElement = e.target.closest('[data-drawer-action]');
        if (!clickedElement) return;
        
        const {
          drawerAction,
          drawerId
        } = clickedElement.dataset;
                        
        switch (drawerAction) {
          case 'open':    
            this.template = document.querySelector(`[data-drawer-content="${drawerId}"]`); 
            if (!this.template) return;       
            
            e.preventDefault();
            this.direction = this.template.dataset?.direction ?? 'left';
            this.classList.add('opacity-0');
            
            document.addEventListener('keydown', e => {
              if (e.key === 'Escape') this.close();
            }, { once: true });
            
            if (this.activeId !== drawerId) {
              this.activeId = drawerId;
              const content = this.template.content?.cloneNode(true) || this.template.cloneNode(true);
              this.replaceChildren(content);
              this.classList.remove('hidden');
              this.classList.add(this.direction);
              setTimeout(() => {
                document.body.classList.add('overlay', 'custom-modal');
                this.classList.add('top-0', 'bottom-0', 'left-0', 'w-full', 'h-full', 'z-[1001]', 'opacity-0');
              }, 10);
              setTimeout(() => {
                this.querySelector('[data-drawer-action="close"]')?.focus();
                this.trapFocus();
              }, 500);
            }
            switch(this.direction) {
              case 'left':
                this.classList.add('-translate-x-full', 'transition-all', 'duration-500');
              break;
              case 'center':
                this.classList.add('transition-all', 'duration-500');
              break;
              case 'right': 
                this.classList.add('translate-x-full', 'transition-all', 'duration-500');
              break;
            }
            
            setTimeout(() => {
              switch(this.direction) {
                case 'left':
                  this.classList.remove('opacity-0', '-translate-x-full')
                break;
                case 'center':
                  this.classList.remove('opacity-0')
                break;
                case 'right': 
                  this.classList.remove('opacity-0', 'translate-x-full')
                break;
              }
            }, 10);
          break;
          case 'close':
            this.close();
          break;
          default: break;
        }
      }));
    }
  }
  
  customElements.define('custom-modal', Modal);
}